import React, { useState } from 'react';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from 'reactstrap';
import { deleteNudgeEmail } from 'utils/api';
import { toast } from 'react-toastify';
import SpinnerButton from 'components/SpinnerButton';

const DeleteNudgeEmailModal = ({item, isOpen, toggle, refreshList}) => {
    const [deleting, setDeleting] = useState(false);

    const onConfirm = async () => {
        try {
            setDeleting(true);
            await deleteNudgeEmail(item.id);
            toast.success('Nudge email successfully deleted');
            await refreshList(true);
            toggle();
        } catch (err) {
            setDeleting(false);
            toast.error('Unable to complete your request at this time');
            console.log(err);
        }
    };

    return (
        <Modal isOpen={isOpen}>
            <ModalHeader toggle={toggle}>
                <strong>Delete Nudge Email</strong>
            </ModalHeader>
            <ModalBody>
                <div style={{ paddingRight: 25 }}>
                    Are you sure you want to delete {item.name}?
                </div>
            </ModalBody>
            <ModalFooter className="select-fetches-modal-footer">
                <Button style={{ color: 'white' }} onClick={toggle}>
                    Cancel
                </Button>
                <SpinnerButton
                    minWidth="85px"
                    onClick={onConfirm}
                    title="Confirm"
                    submitting={deleting}
                />
            </ModalFooter>
        </Modal>
    );
};

export default DeleteNudgeEmailModal;
